/**
 * 檔案用途區塊
 * @module FacebookLogin
 * @purpose 負責在元件載入時觸發 Facebook SSO 導轉流程，組合必要參數後以 replace 方式跳轉。
 * @external https://innotech.atlassian.net/browse/IN-52139
 * @external https://innotech.atlassian.net/browse/IN-52157
 * @external https://innotech.atlassian.net/browse/IN-93752
 */
import React, { useEffect } from 'react';
import { useThirdPartyProvider } from '@shared/models';
import { getSsoUrl } from '@utilities/helpers/ssoUrl.helper';
import { Page } from '@shared/enums/route.enum';

/**
 * 宣告內容用途說明與單號關聯
 * @description Facebook 登入頁的功能元件。
 * @purpose 讀取第三方登入所需資料並在掛載後執行導轉。
 * @external https://innotech.atlassian.net/browse/IN-52139
 */
const FBLogin = () => {
  /**
   * 宣告內容用途說明與單號關聯
   * @description 由第三方登入資料來源取得 OAuth 所需 payload。
   * @purpose 提供 clientId 與 redirectUrl 給 SSO URL 組裝流程使用。
   * @external https://innotech.atlassian.net/browse/IN-52139
   */
  const { payload } = useThirdPartyProvider();

  /**
   * 宣告內容用途說明與單號關聯
   * @description 產生 Facebook SSO 入口並執行頁面替換導轉。
   * @purpose 使用目前 payload 的必要欄位建立登入網址並立即跳轉。
   * @external https://innotech.atlassian.net/browse/IN-52139
   */
  const login = () => {
    location.replace(
      getSsoUrl(Page.FaceBook, {
        clientId: payload.clientId!,
        redirectUrl: payload.redirectUrl!,
      }),
    );
  };

  useEffect(() => login());

  return <></>;
};

export default FBLogin;

/**
 * === llm 分析紀錄區 ===
 * @llm-review-submitted-at 2026-06-14T07:10:37.501Z
 * @llm-review-model gpt-5.3-codex
 * @llm-review-note Added required three-section annotation layout with compliant tags, attached declaration-level Jira links strictly from declarationOrigins, preserved runtime logic unchanged, and appended LLM review record block.
 */
